import React, { Suspense } from "react";

import { Route, Switch } from "react-router-dom";
import { InlineLoading } from "@wfp/ui";

import CountryAdminStocksTable from "components/CountryAdmin/CountryAdminContent/CountryAdminStock/CountryAdminStocksTable";

const CountryAdminStockInspectV2 = React.lazy(() =>
  import(
    "components/CountryAdmin/CountryAdminContent/CountryAdminStock/CountryAdminStockInspectV2"
  )
);

const NeedsReviewQueue = React.lazy(() =>
  import(
    "components/CountryAdmin/CountryAdminContent/CountryAdminStock/NeedsReviewQueue"
  )
);

const CountryAdminStock = () => {
  return (
    <div className="country-admin-main-content">
      <Switch>
        <Route
          path="/countryAdmin/stock/inspect/:stockId?"
          render={(props) => (
            <Suspense fallback={<InlineLoading description="Loading..." />}>
              <CountryAdminStockInspectV2 {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/countryAdmin/stock/needs-review"
          render={(props) => (
            <Suspense fallback={<InlineLoading description="Loading..." />}>
              <NeedsReviewQueue {...props} />
            </Suspense>
          )}
        />
        <Route component={CountryAdminStocksTable} />
      </Switch>
    </div>
  );
};

export default CountryAdminStock;
